'use strict';

var isSidebarOpen = JSON.parse(localStorage.getItem('isSidebarOpen'));

(function ($) {
  var methods = {
    init: function () {
      // options are not used
      // var opts = $.extend({}, $.fn.k2_sidebarToggle.defaults, options);

      return this.each(function () {
        var $this = $(this);

        $this.on('change', function () {
          localStorage.setItem('isSidebarOpen', $this.prop('checked'));
        });

        $this.prop('checked', isSidebarOpen ? true : false);
      });
    }
  };

  $.fn.k2_sidebarToggle = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.sidebarToggle');
    }

  };

  $.fn.k2_sidebarToggle.defaults = {};

})(jQuery);
